import { Link } from "react-router-dom";

export const menuData =[
    { title:'About', Link:'/about'},
    { title:'Home', Link:'/home'},
    { title:'Price', Link:'/price'}
];